// Веб-вклад модуля `visual-explainer` — визуальные разборы.
//
// ЕДИНСТВЕННЫЙ счётчик навигации с `kind: "client"`: `visual_analyses` не
// синкается PowerSync (серверная таблица), поэтому число приходит tRPC-хуком.
// Такой источник обязан иметь запись в `CLIENT_NAV_BADGES` — хук нельзя
// вызвать из данных.

import { SECTION_ICONS, SECTION_TINT } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const visualExplainerWebManifest = {
	id: "visual-explainer",
	icon: SECTION_ICONS.visuals,
	labelKey: "nav.visual",
	tint: SECTION_TINT.visuals,
	// Канонический префикс — `/tools/visual-explainer` (совпал с id модуля,
	// серверным модулем и tRPC-неймспейсом); серверный манифест с 2026-08-14
	// объявляет именно его.
	//
	// `/tools/visuals` остаётся в списке НЕ как «второй раздел», а потому что
	// веб реально обслуживает этот адрес redirect-роутом: строки вида
	// `/tools/visuals/<id>` уже лежат в `notifications.action_url` у живых
	// пользователей. Сервер новые уведомления пишет уже каноном
	// (`generateVisualAnalysis.ts`), так что запись самоочищается по мере
	// протухания старых уведомлений — тогда и убирать, вместе с redirect-роутом.
	routes: ["/tools/visual-explainer", "/tools/visuals"],

	// Баннер объясняет МЕХАНИКУ: разбор зависит от того, что на снимке (у
	// графика читаются оси, у задачи — ход решения), и снимок можно не делать
	// заново, а взять страницей из уже загруженного материала.
	intro: {
		titleKey: "visual-explainer:intro.title",
		bodyKey: "visual-explainer:intro.body",
		bulletKeys: [
			"visual-explainer:intro.bullets.0",
			"visual-explainer:intro.bullets.1",
			"visual-explainer:intro.bullets.2",
		],
	},

	nav: [
		{
			key: "visual-explainer",
			to: "/tools/visual-explainer",
			icon: SECTION_ICONS.visuals,
			labelKey: "nav.visual",
			order: 100,
			badge: { kind: "client" },
		},
	],

	launch: [
		{
			key: "visuals",
			icon: SECTION_ICONS.visuals,
			tint: SECTION_TINT.visuals,
			titleKey: "launcher.visuals",
			hintKey: "launcher.visualsHint",
			to: "/tools/visual-explainer",
			search: { create: true },
			order: 80,
		},
	],
} satisfies WebModuleManifest;
